import React from "react";

type Props = {
  active?: boolean;
  color?: string;
  activeColor?: string;
  size?: number;
};

// Use the provided Lucide-style hotel SVG but wire colors to props so it matches other icons
const HotelIcon: React.FC<Props> = ({
  active = false,
  color = "#636363",
  activeColor = "#204987",
  size = 24,
}) => {
  const stroke = active ? activeColor : color;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M10 22v-6.57" />
      <path d="M12 11h.01" />
      <path d="M12 7h.01" />
      <path d="M14 15.43V22" />
      <path d="M15 16a5 5 0 0 0-6 0" />
      <path d="M16 11h.01" />
      <path d="M16 7h.01" />
      <path d="M8 11h.01" />
      <path d="M8 7h.01" />
      <rect x="4" y="2" width="16" height="20" rx="2" />
    </svg>
  );
};

export default HotelIcon;
